<template lang="pug">
b-container(style="margin-top:40px")
  .tabla.sombra
    ShopifyIntegrationConfig(v-if="checkPermissions([permissions.STORE_SHOPIFY_INTEGRATION])")
    ApiConfig.mt-4(v-if="checkPermissions([permissions.STORE_API_ACCESS])")
    WebhookConfig.mt-4(v-if="checkPermissions([permissions.STORE_API_ACCESS])")
</template>

<script>
import ApiConfig from '../components/integrations/ApiConfig'
import ShopifyIntegrationConfig from '../components/integrations/ShopifyIntegrationConfig'
import WebhookConfig from '../components/integrations/WebhookConfig'
import permissions from '../shared/authUtils'
import { mapGetters } from 'vuex'

export default {
  name: 'ShopifyIntegrationView',
  components: {
    ApiConfig,
    ShopifyIntegrationConfig,
    WebhookConfig
  },
  computed: {
    ...mapGetters(['checkPermissions']),
    permissions () {
      return permissions.permissions
    }
  }
}
</script>
